import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import TelegramBotsList from "./TelegramBotsList";
import TelegramCreateBotDialog from "./TelegramCreateBotDialog";
import DialogModal from "../../../elements/dialogModal/DialogModal";

const TelegramBotsContainer = () => {
  const { t } = useTranslation("telegramBotPage");

  const [bots, setBots]               = useState(null);
  const [deleteId, setDeleteId]       = useState(null);
  const [openDelete, setOpenDelete]   = useState(false);
  const [notification, setNotification] = useState({ visible: false, type: "", message: "" });

  const fetchBots = () => {
    axios.get("/api/telegram/bots", userAuthenticationConfig())
      .then(response => {
        if (response.status === 200) setBots(response.data);
      })
      .catch(error => {
        setNotification({ visible: true, type: "error", message: error?.response?.data?.message || t("bots.errors.load") });
      });
  };

  useEffect(() => {
    fetchBots();
  }, []);

  const deletingBot = bots?.find(b => String(b.projectId) === String(deleteId));

  const handleDeleteBot = () => {
    axios.delete(`/api/telegram/bots/${deleteId}`, userAuthenticationConfig())
      .then(() => {
        setOpenDelete(false);
        setNotification({ visible: true, type: "success", message: t("bots.success.deleted") });
        fetchBots();
      })
      .catch(error => {
        setNotification({ visible: true, type: "error", message: error?.response?.data?.message || t("bots.errors.delete") });
      });
  };

  return (
    <>
      <Notification notification={notification} setNotification={setNotification} />
      <TelegramCreateBotDialog
        setNotification={setNotification}
        onCreated={fetchBots}
        t={t}
      />
      <DialogModal
        open={openDelete}
        setOpen={setOpenDelete}
        title={t("bots.dialog.deleteTitle")}
        content={t("bots.dialog.deleteText", { project: deletingBot?.projectName })}
        cancelButton={t("bots.dialog.cancel")}
        approveButton={t("bots.dialog.delete")}
        onApprove={handleDeleteBot}
      />
      <TelegramBotsList
        bots={bots}
        onDelete={(projectId) => { setDeleteId(projectId); setOpenDelete(true); }}
        t={t}
      />
    </>
  );
};

export default TelegramBotsContainer;
